export const bizCareNoReturns = [
  "cst250us",
  "csp102ul",
  "csc246u",
  "ccs250u",
  "cst346ms",
  "cst346ls",
  "cst446ms",
  "cst446ls",
  "cst447ls",
  "csp241ll",
  "cst245ls",
  "cst313ls",
  "cst313ms",
];

export const dahliaShirts = ["rb365l", "rb366lt"];

export const availableDateMessage = (slug: string) => {
  const availableMidJuly = [
    "ru568ls",
    "ru568ll",
    "ro571ls",
    "ru570ll",
  ].includes(slug);
  const availableEndJuly = ["ru569ls", "ru569ll"].includes(slug);
  const availableAugust = ["ra572m"].includes(slug);
  const availableLate2025 = ["p515ms", "p515ls"].includes(slug);

  if (availableMidJuly) return "Available Mid July";
  if (availableEndJuly) return "Available End of July";
  if (availableAugust) return "Available August";
  if (availableLate2025) return "Available late 2025";
};
